import { gql } from "@apollo/client";

export const ADD_ADDRESS = gql`
    mutation AddAddress(
        $address1: String!,
        $districtId: Int,
        $cityId: Int!,
        $reference: String,
        $addressType: TipoDireccion!
        $principal: Boolean
    ) {
        agregarDireccion(input: {
            direccion: $address1
            distritoId: $districtId
            ciudadId: $cityId
            referencia: $reference
            tipoDireccion: $addressType
            principal: $principal
        }) {
            direccion {
                id
                direccion
                distritoId
                distrito
                ciudadId
                ciudad
                departamentoId
                departamento
                paisId
                pais
                referencia
                principal
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export const UPDATE_ADDRESS = gql`
    mutation UpdateAddress(
        $id: ID!,
        $address1: String!,
        $districtId: Int,
        $cityId: Int!,
        $reference: String,
        $principal: Boolean
    ) {
        editarDireccion(input: {
            id: $id
            direccion: $address1
            distritoId: $districtId
            ciudadId: $cityId
            referencia: $reference
            principal: $principal
        }) {
            direccion {
                id
                direccion
                distritoId
                distrito
                ciudadId
                ciudad
                departamentoId
                departamento
                paisId
                pais
                referencia
                principal
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export const MAKE_PRIMARY_ADDRESS = gql`
    mutation UpdateAddress(
        $id: ID!,
        $principal: Boolean!
    ) {
        editarDireccion(input: {
            id: $id
            principal: $principal
        }) {
            direccion {
                id
                principal
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export const DELETE_ADDRESS = gql`
    mutation DeleteAddress($id: ID!) {
        eliminarDireccion(id: $id) {
            direccion {
                id
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;
